import createLucideIcon from '../createLucideIcon';

const Rewind = createLucideIcon('RewindIcon', [
  ['polygon', { points: '11 19 2 12 11 5 11 19', key: '14yba5' }],
  ['polygon', { points: '22 19 13 12 22 5 22 19', key: '1pi1cj' }],
]);

export default Rewind;
